import { render, staticRenderFns } from "./PurchaseSearch.vue?vue&type=template&id=2b381154"
import script from "./PurchaseSearch.vue?vue&type=script&lang=ts"
export * from "./PurchaseSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b381154')) {
      api.createRecord('2b381154', component.options)
    } else {
      api.reload('2b381154', component.options)
    }
    module.hot.accept("./PurchaseSearch.vue?vue&type=template&id=2b381154", function () {
      api.rerender('2b381154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseSearch.vue"
export default component.exports